const NEW_LINE = /\r|\n|\r\n/g;
export const splitLines = text => {
  return text.split(NEW_LINE);
};